// --Evenement: #ed6505;
// --Legislation: #186a0f;
// --services: #55f7df;
// --cooperation: #2933ff;
// --personell: #fdd00c;
// --transport: #b413da;
// --batiments: #ff3e4c;
// --Technologie: #13d436;

export const COLLECTION_DATE_TYPES = [
  "advertising",
  "book",
  "building",
  "image",
  "law",
  "map",
  "object",
  "other",
  "video"
];

export const EVENT_COLORS = {
  cooperation: "#ed6505",
  infrastructure: "#186a0f",
  "legislation and events": "#55f7df",
  service: "#2933ff",
  staff: "#fdd00c",
  technology: "#13d436"
};

export const TYPE_ICON = {
  "360viewer": "3d_rotation",
  image: "photo",
  pdf: "library_books",
  video: "play_circle_filled",
  audio: "audiotrack"
};

export const MAP_ICON = {
  office: "local_post_office",
  central: "settings_input_antenna",
  telegraph: "settings_ethernet"
};

export const MAP_PLACE_TYPE = [
  { label: "branch", icon: "branch" },
  { label: "office", icon: "office" },
  { label: "HQ", icon: "headquarter" }
];
